import { useCartContext } from "app/providers/CartProvider";
import { useMemo } from "react";
import Heading from "shared/ui/typography/Heading";
import Text from "shared/ui/typography/Text";
import { concatClassnames } from "shared/utils/concatClassnames";

enum PanelReceiveMethod {
  ASSEMBLY = "ASSEMBLY",
  DELIVERY = "DELIVERY",
  PICK_UP_ESD = "PICK_UP_ESD",
  PICK_UP_VILLAARENA = "PICK_UP_VILLAARENA",
}

const APPOINTMENT_PANEL_HEADER_MAPS: Record<
  PanelReceiveMethod,
  { title: string; description: string }
> = {
  [PanelReceiveMethod.ASSEMBLY]: {
    title: "Plan je afspraak om je bestelling te laten monteren",
    description: `We komen binnenkort naar je toe! Kies in de kalender hiernaast een geschikte datum voor de levering 
      van je bestelling. Twee dagen van tevoren ontvang je van ons een tijdsindicatie waarin je onze monteur kunt 
      verwachten.`,
  },
  [PanelReceiveMethod.DELIVERY]: {
    title: "Plan je afspraak om je bestelling te laten bezorgen",
    description: `We komen binnenkort naar je toe! Kies in de kalender hiernaast een geschikte datum voor de levering 
      van je bestelling. Twee dagen van tevoren ontvang je van ons een tijdsindicatie waarin je onze bezorger kunt 
      verwachten.`,
  },
  [PanelReceiveMethod.PICK_UP_ESD]: {
    title: "Plan je afspraak om je bestelling op te halen",
    description: `Gezellig! Jij komt je bestelling binnenkort bij ons afhalen bij showroom Vlaardingen. Kies de
      gewenste datum voor afhalen in de kalender hiernaast. Wij zorgen dat je bestelling bij ons klaarstaat!`,
  },
  [PanelReceiveMethod.PICK_UP_VILLAARENA]: {
    title: "Plan je afspraak om je bestelling op te halen",
    description: `Gezellig! Jij komt je bestelling binnenkort bij ons afhalen bij showroom Amsterdam. Kies de
      gewenste datum voor afhalen in de kalender hiernaast. Wij zorgen dat je bestelling bij ons klaarstaat!`,
  },
};

interface CheckoutPanelDatePickerHeaderProps {
  className?: string;
}
const CheckoutPanelDatePickerHeader = ({
  className,
}: CheckoutPanelDatePickerHeaderProps) => {
  const cart = useCartContext().getCart();

  const currentPanelReceiveMethod: PanelReceiveMethod = useMemo(() => {
    if (cart.pickupWarehouse === "ESD") return PanelReceiveMethod.PICK_UP_ESD;
    if (cart.pickupWarehouse === "VillaArena")
      return PanelReceiveMethod.PICK_UP_VILLAARENA;

    if (cart.bumbalFlow === "placement") {
      return PanelReceiveMethod.ASSEMBLY;
    }

    return PanelReceiveMethod.DELIVERY;
  }, [cart.pickupWarehouse]);

  return (
    <header className={concatClassnames("", className)}>
      <Heading headingLevel="h2" className="gg-mb-1 gg-text-2xl">
        {APPOINTMENT_PANEL_HEADER_MAPS[currentPanelReceiveMethod].title}
      </Heading>
      <Text className="gg-mb-7 gg-mt-2">
        {APPOINTMENT_PANEL_HEADER_MAPS[currentPanelReceiveMethod].description}
      </Text>
    </header>
  );
};
export default CheckoutPanelDatePickerHeader;
